import { useLanguage } from '../context/LanguageContext';
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CGU() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#00aaff] mb-6 transition-colors">
          <ArrowLeft size={18} />
          <span className="text-sm">Retour à l'accueil</span>
        </Link>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-8">Conditions Générales d'Utilisation</h1>

        <div className="prose prose-gray max-w-none space-y-8">
          {/* Préambule */}
          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du site internet <strong>joeycyan.com</strong> édité par la société <strong>Joey Cyan</strong> (SIRET : 830 404 588 00014).
            </p>
            <p className="text-gray-700 leading-relaxed">
              L'utilisation du site implique l'acceptation pleine et entière des présentes CGU.
            </p>
          </section>

          {/* Article 1 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 1 - Objet</h2>
            <p className="text-gray-700 leading-relaxed">
              Les présentes CGU ont pour objet de définir les modalités et conditions d'utilisation du site joeycyan.com ainsi que les droits et obligations des utilisateurs.
            </p>
          </section>

          {/* Article 2 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 2 - Accès au site</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le site joeycyan.com est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. Tous les frais supportés par l'utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Joey Cyan met en œuvre tous les moyens raisonnables à sa disposition pour assurer un accès de qualité au site, mais n'est tenue à aucune obligation d'y parvenir. Joey Cyan ne peut être tenue responsable de tout dysfonctionnement du réseau ou des serveurs ou de tout autre événement échappant au contrôle raisonnable, qui empêcherait ou dégraderait l'accès au site.
            </p>
          </section>

          {/* Article 3 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 3 - Création de compte</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour passer commande, l'utilisateur doit créer un compte en fournissant les informations suivantes :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Nom et prénom</li>
              <li>Adresse email valide</li>
              <li>Mot de passe sécurisé</li>
              <li>Numéro de téléphone (optionnel)</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4 mb-4">
              L'utilisateur s'engage à fournir des informations exactes et à les maintenir à jour. Il est responsable de la confidentialité de ses identifiants de connexion.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En cas d'utilisation frauduleuse de son compte, l'utilisateur doit immédiatement en informer Joey Cyan à l'adresse : contact@joeycyan.com
            </p>
          </section>

          {/* Article 4 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 4 - Utilisation du site</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              L'utilisateur s'engage à utiliser le site de manière loyale et conforme à sa destination. Il s'interdit notamment de :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Utiliser le site à des fins illégales ou frauduleuses</li>
              <li>Tenter d'accéder de manière non autorisée aux systèmes informatiques du site</li>
              <li>Diffuser des contenus illicites, diffamatoires, injurieux, racistes ou contraires à l'ordre public</li>
              <li>Utiliser des robots, scripts ou tout autre moyen automatisé pour accéder au site</li>
              <li>Perturber le bon fonctionnement du site</li>
            </ul>
          </section>

          {/* Article 5 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 5 - Propriété intellectuelle</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Tous les éléments du site joeycyan.com (structure, textes, logos, images, vidéos, sons, bases de données, logiciels, etc.) sont protégés par le droit d'auteur, le droit des marques et/ou tout autre droit de propriété intellectuelle.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Joey Cyan.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Toute exploitation non autorisée du site ou de l'un de ses éléments sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
            </p>
          </section>

          {/* Article 6 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 6 - Liens hypertextes</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le site peut contenir des liens hypertextes vers d'autres sites internet. Joey Cyan ne dispose d'aucun contrôle sur ces sites tiers et décline toute responsabilité quant à leur contenu.
            </p>
            <p className="text-gray-700 leading-relaxed">
              La création de liens hypertextes vers le site joeycyan.com est soumise à l'autorisation préalable de Joey Cyan.
            </p>
          </section>

          {/* Article 7 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 7 - Données personnelles</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Joey Cyan collecte et traite des données personnelles dans le respect du Règlement Général sur la Protection des Données (RGPD) et de la loi Informatique et Libertés.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Pour plus d'informations sur la collecte et le traitement de vos données personnelles, consultez notre <Link to="/politique-confidentialite" className="text-[#00aaff] hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          {/* Article 8 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 8 - Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              Le site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Pour plus d'informations, consultez notre <Link to="/politique-cookies" className="text-[#00aaff] hover:underline">Politique de Cookies</Link>.
            </p>
          </section>

          {/* Article 9 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 9 - Responsabilité</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Joey Cyan s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Joey Cyan ne pourra également être tenue responsable des dommages directs et indirects causés au matériel de l'utilisateur lors de l'accès au site, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées, soit de l'apparition d'un bug ou d'une incompatibilité.
            </p>
          </section>

          {/* Article 10 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 10 - Suspension et résiliation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Joey Cyan se réserve le droit de suspendre ou de supprimer l'accès d'un utilisateur au site, sans préavis ni indemnité, en cas de :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Violation des présentes CGU</li>
              <li>Fourniture d'informations fausses ou trompeuses</li>
              <li>Comportement frauduleux ou illicite</li>
              <li>Non-paiement d'une commande</li>
            </ul>
          </section>

          {/* Article 11 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 11 - Modification des CGU</h2>
            <p className="text-gray-700 leading-relaxed">
              Joey Cyan se réserve le droit de modifier les présentes CGU à tout moment. Les nouvelles CGU seront portées à la connaissance des utilisateurs par leur mise en ligne sur le site. Il est donc conseillé de consulter régulièrement les présentes CGU.
            </p>
          </section>

          {/* Article 12 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 12 - Droit applicable et juridiction</h2>
            <p className="text-gray-700 leading-relaxed">
              Les présentes CGU sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français compétents.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-gray-50 p-6 rounded-xl">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour toute question concernant les présentes CGU :
            </p>
            <ul className="list-none space-y-2 text-gray-700 ml-0">
              <li><strong>Joey Cyan</strong></li>
              <li>33 Avenue Philippe Auguste, 75011 Paris</li>
              <li>Email : contact@joeycyan.com</li>
              <li>SIRET : 830 404 588 00014</li>
            </ul>
          </section>
        </div>

        <p className="text-sm text-gray-400 mt-12">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
      </div>
    </div>
  );
}
